import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SpeakToYourAgentCardShort from 'components/SpeakToYourAgentCardShort';
import SpeakToYourAgentCardWide from 'components/SpeakToYourAgentCardWide';
import DefaultHeader from 'components/pageLayout/DefaultHeader';
import Layout from 'components/pageLayout/Layout';
import PageContentContainer from 'components/pageLayout/PageContentContainer';
import Pagination from 'components/pagination/Pagination';
import QuoteBookingCardList from 'components/quoteBooking/QuoteBookingCardList';
import SectionTitle from 'components/typography/SectionTitle';
import { getLatestBookingsAndQuotes } from 'services/CommonService';

export default function QuotesListPage() {
  const { latestQuotes, componentConfig } = useSelector((state) => state.ui);
  const perPageLimit = 6;
  const [quotesList, setQuotesList] = useState(latestQuotes);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();

  const loadQuotesList = useCallback(async () => {
    try {
      const {
        data: {
          quotes: { results, _meta: meta },
        },
      } = await getLatestBookingsAndQuotes(
        `_sort=outbound&_page=${currentPage}&_results=${perPageLimit}`,
      );

      if (results) {
        setQuotesList(results);
        setCurrentPage(meta.currentPage);
        setTotalPages(meta.totalPages);
      }
    } catch (error) {
      console.error(error);
    }
  }, [currentPage]);

  const nextPageHandler = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const previousPageHandler = () => {
    if (currentPage <= totalPages && currentPage > 1)
      setCurrentPage(currentPage - 1);
  };

  useEffect(() => {
    loadQuotesList();
  }, [loadQuotesList]);

  return (
    <Layout>
      <DefaultHeader label="Quotes" />
      <PageContentContainer>
        <SectionTitle
          className="mx-4 grid:mx-0 mt-[40px] text-[24px] md:text-[28px] font-medium"
          label="Active quotes"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[40px] w-full">
          <QuoteBookingCardList list={quotesList?.slice(0, 3)} />
        </div>
        {componentConfig.contactAgentEnabled && (
          <>
            <SpeakToYourAgentCardWide type="quote" />
            <div className="block lg:hidden">
              <SpeakToYourAgentCardShort type="quote" />
            </div>
          </>
        )}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[40px] w-full">
          <QuoteBookingCardList list={quotesList?.slice(3)} />
        </div>
        <div className="flex flex-wrap mx-4 mt-[40px] grid:mx-0">
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              nextPageFn={nextPageHandler}
              prevPageFn={previousPageHandler}
            />
          )}
        </div>
      </PageContentContainer>
    </Layout>
  );
}
